import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import base from "components/UI/Theme";

import {
  light,
  grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tertiaryColor,
  bodyColor,
  titleColor,
  textColor,
  bannerBackgroundColor,
} from 'helpers/colors';

const local={
  ...base,
    palette: {
      ...base.palette,
      type: 'light',
      template: {
        color: textColor,
      },    
      primary: {
        main: primaryColor,
        light: primaryColor,
      },
      secondary: {
        main: secondaryColor,
        contrastText: '#fff',
      },
      tertiary: {
        main: tertiaryColor,
      },
      text: {
        primary: textColor,
        secondary: textColor,
        light,
        dark,
      },
      action: {
        disabled: disabledColor,
      },
      background: {
        default: '#f5f5f5',
        // input: primaryColor,
        // paper: '#fff',
      },
      news: {
        backgroundColor: '#F4F4F4',
        color: '#212121',
      },
      replays: {
        breadCrumbColor: '#fff',
        backgroundColor: '#b80e80',
      },
      live: {
        breadCrumbColor: '#fff',
        backgroundColor: '#b80e80',
      },
      banner:{
        color:'#fff',
        backgroundColor: bannerBackgroundColor,
        backgroundImage:'url('+(require('assets/images/banner_bg.svg'))+')',
      },
      footer:{
        color:'#fff',
        background:'#5a2d80',
      },
      faq:{
        backgroundColor:'red',
        itemColor:'#333',
        bulletColor:primaryColor,
        mainColor:'#333',
        answerColor:'#777',
        itemBackgroundColor:'white',
        itemShadow:'none',
      },
      rgpd: {
        backgroundColor: '#5a2d80',
        color: '#fff',
      },
    },
    typography: {
      fontFamily: ['Montserrat, Helvetica, Arial, sans-serif'].join(','),
      useNextVariants: true,
      h1: {
        color: titleColor || light,
        fontWeight: 'bold',
        // display: 'inline-block',
        fontSize: '2.6rem',
        // borderBottom: (titleColor || light) + ' 1px solid',
        marginBottom: 30,
        // paddingBottom: 10,
        letterSpacing: 2,

        paddingTop: 16,
        paddingBottom: 16,
        color: primaryColor,
        textAlign: 'center',
        fontSize: '1.6rem',
        fontWeight: 'normal',
        // backgroundColor: '#fff',
        width: '100%',

      },
      h2: {
        textAlign: 'center',
        fontSize: '2.1rem',
        lineHeight: '2.4rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        display: 'block',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',

        // fontWeight:
        // fontWeight: 400,
        // lineHeight: 0.95,
        // letterSpacing: 2,
      },
      h3: {
        color: primaryColor,
        fontSize: '1.2rem',
        fontWeight: 400,
        marginBottom: 30,
        paddingBottom: 10,
        paddingTop: 10,
        //textTransform: 'uppercase',
        // border: primaryColor + ' 1px solid',
        textAlign: 'left',
      },
      h4: {
        // color: primaryColor,
        color: 'inherit',
        fontSize: '1.4rem',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        marginBottom: 24,
      },
      h5: {
        // color: primaryColor,
        color: 'inherit',
        fontSize: '1.2rem',
        // fontWeight: 'bold',
        marginTop: '24px',
        position: 'relative',
      },
      h6: {
        color: primaryColor,
        fontSize: '1.1rem',
        // paddingBottom: 10,
        // paddingTop: 10,
        // paddingLeft: 16,
        // paddingRight: 16,
        // border: primaryColor + ' 1px solid',
        textAlign: 'left',
        // marginBottom: 32
      },
      body1: {
        fontSize: '1rem',
        color: 'inherit',
        // color: primaryColor,
      },
      body2: {
        fontSize: '1rem',
        color: primaryColor,
      },
      subtitle1: {
        color: primaryColor,
        fontSize: '1rem',
      },
      subtitle2: { color: secondaryColor, fontSize: '1rem' },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    overrides: {
      MuiSvgIcon: {
        root: {
          display: 'inline-block',
          verticalAlign: 'middle',
          marginTop: -3,
          marginRight: 4
        }
      },
      MuiButton: {
        
        root: {
          /*
          textTransform: 'none',
          backgroundColor: primaryColor,
          color: secondaryColor,
          '&:hover': {
            backgroundColor: secondaryColor,
            color: primaryColor,
          },
          '&$disabled': {
            color: '#fff'
          }
          // '&.MuiButton-sizeLarge': {
          //   padding: '8px 50px',
          // },
          */
        },
        
        /*
        textSecondary: {
          color: primaryColor
        },
        textSizeSmall: {
          color: primaryColor
        },*/
        containedPrimary: {
          backgroundColor: primaryColor,
          color: secondaryColor,
          fontWeight: 'bold',
          textTransform: 'none',
          opacity: 0.8,
          '&:hover': {
            color: primaryColor,
            backgroundColor: secondaryColor,
          },
        },
        containedSecondary: {
          backgroundColor: secondaryColor,
          color: primaryColor,
          fontWeight: 'bold',
          textTransform: 'none',
          opacity: 0.8,
          '&:hover': {
            color: secondaryColor,
            backgroundColor: primaryColor,
          },
        },
        outlinedPrimary: {
          backgroundColor: primaryColor,
          color: secondaryColor,
          textTransform: 'none',
          border:primaryColor+' 1px solid',
          fontWeight: 'bold',
          '&:hover': {
            color: primaryColor,
            backgroundColor: secondaryColor,
          },
          '&.Mui-disabled': {
            backgroundColor: '#ccc',
            opacity: 0.7,
          },
        },
        outlinedSecondary: {
          backgroundColor: secondaryColor,
          fontWeight: 'bold',
          color: primaryColor,
          textTransform: 'none',
          border:tertiaryColor+' 1px solid',
          '&:hover': {
            color: secondaryColor,
            backgroundColor: primaryColor,
            border:primaryColor+' 1px solid',
          },
          '&.Mui-disabled': {
            backgroundColor: '#ccc',
            opacity: 0.7,
          },
        },
        textSecondary: {
          boxShadow: 'none',
          color: primaryColor,
          textTransform: 'none',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: "#b80e800f",//magenta clair
          },
          '&.Mui-disabled': {
            backgroundColor: '#ccc',
            opacity: 0.7,
          },
        },
      },
      MuiFormLabel: {
        root: {
          // color: '#fff',
          '&.Mui-focused': {
            color: primaryColor,
          },
        },
      },
      MuiFormHelperText: {
        root: {
          color: primaryColor,
        },
      },
      'MuiStepper-root': {
        padding: 0,
      },
      MuiStep: {
        root: {
          '& > .MuiStepConnector-root': {
            display: 'none',
          },
        },
      },
      MuiMenuItem: {
        root: {
          // color: '#fff',
        },
      },
      MuiAlert: {
        standardSuccess: {
          // color: '#fff',
          fontWeight: 'bold'
        }
      },
      MuiAppBar: {
        colorPrimary: {
          //backgroundColor: "transparent",
        }
      },
      MuiTab:{
        root:{
          textTransform: 'none',
        },
      },
    },
};

export default class Theme extends React.Component {
  render() {
    const { children } = this.props;

    const theme = createMuiTheme(local);

    theme.overrides.MuiButton.root.boxShadow = theme.shadows[2];
    theme.typography.h1 = {
      ...theme.typography.h1,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      // boxShadow: theme.shadows[3],
      [theme.breakpoints.down('md')]: {
        fontSize: '1.4rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.3rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.1rem',
      },
    };

    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx